var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomArrowFaqs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56984 3.81567L0.134161 0.951944C-0.206883 0.550964 0.141666 -2.13949e-08 0.736378 0L5.26362 1.62869e-07C5.85833 1.84264e-07 6.20688 0.550965 5.86584 0.951945L3.43015 3.81568C3.22112 4.06144 2.77888 4.06144 2.56984 3.81567Z",
    fill: "#041E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrowFaqs);
export default __webpack_public_path__ + "static/media/bottom-arrow-faqs.e06e66218f6d216341f2c78d9617950c.svg";
export { ForwardRef as ReactComponent };